import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { useAcoesVisita } from "../lib/acoesVisita";
import { buscarVisitas } from "../lib/visitas";
import { moeda } from "../lib/formato";
import { Cabecalho } from "../components/Layout";
import { TabelaVisitas } from "../components/TabelaVisitas";
import type { Visita } from "../lib/tipos";

export default function Matriculas() {
  const { podeAoMenos } = useAuth();
  const podeEditar = podeAoMenos("CONSULTOR");
  const [itens, setItens] = useState<Visita[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const r = await buscarVisitas({ status: "FECHOU_MATRICULA", porPagina: 500 });
      setItens(r.itens);
      setErro("");
    } catch (e) {
      setErro(e instanceof Error ? e.message : "Falha ao carregar");
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);
  const acoes = useAcoesVisita(carregar);

  const totalAnual = itens.reduce((acc, v) => acc + Number(v.proposta?.valorAnual ?? 0), 0);

  return (
    <>
      <Cabecalho titulo="Matrículas" />
      <div style={{ display: "flex", gap: 12, marginBottom: 18, flexWrap: "wrap" }}>
        <div className="cartao" style={{ flex: "0 1 220px" }}>
          <div style={{ fontSize: 12, color: "var(--texto-suave)" }}>Matrículas fechadas</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: "#079455" }}>{itens.length}</div>
        </div>
        <div className="cartao" style={{ flex: "0 1 280px" }}>
          <div style={{ fontSize: 12, color: "var(--texto-suave)" }}>Investimento anual somado</div>
          <div style={{ fontSize: 24, fontWeight: 700, color: "var(--verde)" }}>{moeda(totalAnual)}</div>
        </div>
      </div>
      {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}
      <TabelaVisitas
        visitas={itens}
        carregando={carregando}
        vazio="Nenhuma matrícula fechada ainda"
        colunas={["responsavel", "aluno", "telefone", "curso", "serie", "inicio", "valor"]}
        podeEditar={podeEditar}
        onEditar={acoes.abrirEdicao}
        onFicha={acoes.abrirFicha}
        onExcluir={acoes.excluir}
      />
      {acoes.modais}
    </>
  );
}
